import React from 'react'
import './Fow.css'
import arrow from './assets/Arrow.png'
import terminal from './assets/Terminal.png'
import proc from './assets/Processs.png'
import dec from './assets/Decision.png'
import input from './assets/Input.png'
import annot from './assets/Annotation.png'
import predef from './assets/Predefined process.png'
import connector from './assets/Connector.png'
import off from './assets/off page connector.png'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
 import flow from '../Languages/assets/Flowchart example.jpg'
const Flow_Pseudo = () => {
    return (
        <div>
            <div className='container'>
            <h3>What is Flow-Chart?</h3>
            <p>A flowchart is a diagram that depicts a process, system or 
                computer algorithm. They are widely used in multiple fields to 
                document, study, plan, improve and communicate often complex processes
                 in clear, easy-to-understand diagrams. Flowcharts, sometimes spelled 
                 as flow charts, use rectangles, ovals, diamonds and potentially 
                 numerous other shapes to define the type of step, along with 
                 connecting arrows to define flow and sequence. They can range from simple,
                 hand-drawn charts to comprehensive computer-drawn diagrams depicting 
                 multiple steps and routes. If we consider all the various forms of flowcharts,
                  they are one of the most common diagrams on the planet, used by both 
                  technical and non-technical people in numerous fields. Flowcharts are 
                  sometimes called by more specialized names such as Process Flowchart, 
                  Process Map, Functional Flowchart, Business Process Mapping, Business 
                  Process Modeling and Notation (BPMN),  or Process Flow Diagram (PFD). 
                  They are related to other popular diagrams, such as Data Flow Diagrams (DFDs)
                   and Unified Modeling Language (UML) Activity Diagrams.</p>
                   </div>
            <table>
  <caption>Common Symbols</caption>
  <thead>
    <tr>
      <th scope="col">ANSI/ISO</th>
      <th scope="col">Name</th>
      <th scope="col">Description</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td data-label="ANSI/ISO"><img src={arrow} alt="" /></td>
      <td data-label="Name">Flowline (Arrowhead)</td>
      <td data-label="Description">Shows the process's order of operation. A line coming from one symbol and pointing at another. Arrowheads are added if the flow is not the standard top-to-bottom, left-to right.</td>
    </tr>
    <tr>
      <td scope="row" data-label="ANSI/ISO"><img src={terminal } alt="" /></td>
      <td data-label="Name">Terminal</td>
      <td data-label="Description">Indicates the beginning and ending of a program or sub-process. Represented as a stadium, oval or rounded (fillet) rectangle. They usually contain the word "Start" or "End", or another phrase signaling the start or end of a process, such as "submit inquiry" or "receive product".</td>
    </tr>
    <tr>
      <td scope="row" data-label="ANSI/ISO"><img src={proc} alt="" /></td>
      <td data-label="Name">Process</td>
      <td data-label="Description">Represents a set of operations that changes value, form, or location of data. Represented as a rectangle.</td>
    </tr>
    <tr>
      <td scope="row" data-label="Acount"><img src={dec} alt="" /></td>
      <td data-label="Name">Decision</td>
      <td data-label="Description">Shows a conditional operation that determines which one of the two paths the program will take.The operation is commonly a yes/no question or true/false test. Represented as a diamond (rhombus)</td>
    </tr>
    <tr>
      <td scope="row" data-label="Acount"><img src={input} alt="" /></td>
      <td data-label="Name">Input/Output</td>
      <td data-label="Description">Indicates the process of inputting and outputting data,[15] as in entering data or displaying results. Represented as a rhomboid.</td>
    </tr>
    <tr>
      <td scope="row" data-label="Acount"><img src={annot} alt="" /></td>
      <td data-label="Name">Annotation</td>
      <td data-label="Description">Indicating additional information about a step in the program. Represented as an open rectangle with a dashed or solid line connecting it to the corresponding symbol in the flowchart.</td>
    </tr>
    <tr>
      <td scope="row" data-label="Acount"><img src={ predef} alt="" /></td>
      <td data-label="Name">Predefined Process</td>
      <td data-label="Description">Shows named process which is defined elsewhere. Represented as a rectangle with double-struck vertical edges.</td>
    </tr>
    <tr>
      <td scope="row" data-label="Acount"><img src={ connector} alt="" /></td>
      <td data-label="Name">On-page Connector</td>
      <td data-label="Description">Pairs of labeled connectors replace long or confusing lines on a flowchart page. Represented by a small circle with a letter inside.</td>
    </tr>
    <tr>
      <td scope="row" data-label="Acount"><img src={off} alt="" /></td>
      <td data-label="Name">Off-page Connector</td>
      <td data-label="Description">A labeled connector for use when the target is on another page. Represented as a home plate-shaped pentagon</td>
    </tr>
  </tbody>
</table>
<div className='container'>
  <h3>for Example:</h3> <br />
  <p>Now let's take an example of flowchart to understand it in a clear way that how to use all the symbols given above and draw pictorial representation that tells the solution of any program or problem.
<br />
<h4>Draw flowchart to find largest of three numbers:</h4> <br />
Here the figure given below shows the flowchart that helps in finding the largest of three numbers:</p> <br />
<p>Let the A, B and C be 5, 10 and 15</p> <br />
<p> First computer will the start the program,Then it will read A,B,and C as 5,10 and 15</p><br />
<p>Now as our first condition is A &#5172; B now our A is 5and B is 10 so clearly it condition will not satisfy </p> <br />
<p>And check for second condition B &#5176; C now our B is 10 an C is 15 so cleary now it will satisfy the condition  </p><br />
<p>There for it will, Print C</p> 
   <img src={flow} alt="" /> 
  </div>
        </div>
    )
}

export default Flow_Pseudo
